import { AttrMapping, IData } from "@utils/AttrMapping";

export type IDNSystemiModel = IData & {
    cpvKod: string;
    datumZavedeni: Date;
    delkaMesic: number;
    delkaRok: number;
    nazev: string;
    pocetDod: number;
    podaniLhuta: Date;
    predmet: string;
    stav: number;
    terminUkonceni: Date;
    vz: number;
    vzHierarchie: number;
    zadavatelNazev: string;
    zadavatelICO: string;
    zadavatelID: number;
    zakazka: string;
    zakazkaKod: string;
    
}

export const DNSystemAttrMap = new AttrMapping<IDNSystemiModel>('DNSystem', [
    { clientName: 'id', serverName: 'ID', type: 'id' },
    { clientName: 'cpvKod', serverName: 'Hist.CPV_predmetu.Kod', type: 'string' },
    { clientName: 'datumZavedeni', serverName: 'Datum_zavedeni', type: 'dateTime' },
    { clientName: 'delkaMesic', serverName: 'Delka_trvani_mesice', type: 'number' },
    { clientName: 'delkaRok', serverName: 'Delka_trvani_roky', type: 'number' },
    { clientName: 'nazev', serverName: 'Nazev_DNS', type: 'string' },
    { clientName: 'pocetDod', serverName: 'Pocet_dodavatelu', type: 'number' },
    { clientName: 'podaniLhuta', serverName: 'Hist.Podani_nabidka.Lhuta', type: 'dateTime' },
    { clientName: 'predmet', serverName: 'Predmet', type: 'text' },
    { clientName: 'stav', serverName: 'Stav', type: 'enum', typeParam: 'Stav_DNS' },
    { clientName: 'terminUkonceni', serverName: 'Termin_ukonceni', type: 'date' },
    { clientName: 'vz', serverName: 'VZ', type: 'id' },
    { clientName: 'vzHierarchie', serverName: 'ZP_celek', type: 'id' },
    { clientName: 'zadavatelNazev', serverName: 'Hist.Zadavatel.Nazev', type: 'string' },
    { clientName: 'zadavatelICO', serverName: 'Hist.Zadavatel.ICO', type: 'string' },
    { clientName: 'zadavatelID', serverName: 'Hist.Zadavatel', type: 'id' },
    { clientName: 'zakazka', serverName: 'VZ_KodNazev_celek', type: 'string' },
    { clientName: 'zakazkaKod', serverName: 'Hist.Kod', type: 'string' },
    
]);
